import DocumentViewerModal from "components/DocumentViewer";
import { useTranslation } from "contexts/i18nContext";
// import { StatusChip } from "components/StatusChip";
// import { useTranslation } from "contexts/i18nContext";
// import { useHasRole } from "contexts/AuthContext";
import { useState } from "react";
import {
  Complaints,
  CouncilLitigation,
  CouncilOfficeVerdictInitialDay,
} from "types";
// import { APPEAL_STATUS, APPEAL_TYPE } from "utils/constantValues";
// import { ROLES } from "utils/roles";

interface AppealProps {
  complaintData: Complaints;
  councilLitigationData: CouncilLitigation;
  onAppealRefresh: any;
  showHearingHistory?: Boolean;
}

export default function InitialDecisionCard({
  complaintData,
  councilLitigationData,
  showHearingHistory = false,
  onAppealRefresh,
}: AppealProps) {
  const { t } = useTranslation();
  const [, setShowDailyHearing] = useState(false);
  const [, setSelectedAppeal] = useState({});

  return (
    <div className="space-y-4">
      {/* ////////////// */}
      {councilLitigationData?.initial_day_verdicts?.map(
        (obj: CouncilOfficeVerdictInitialDay) => (
          <div
            key={obj?.id}
            className="bg-white shadow-md rounded-xl p-4 w-full border-l-8 border-black mx-auto"
          >
            {/* Header */}
            {/* <div className="flex items-center gap-3 mb-4">
          <img
            src={require("../../../images/avatar.png")}
            alt="profile"
            className="w-10 h-10 rounded-full object-cover"
          />
          <div>
            <h2 className="text-sm font-semibold">Senay Daniel</h2>
            <p className="text-xs text-gray-500">Investigation Team</p>
          </div>
        </div> */}

            {/* <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
          <p className="block text-gray-600">Uploaded Date</p>
          <p className="block text-black font-medium">
            {new Date()?.toDateString() || "-"}
          </p>
          </div>
          <hr />
           */}

            <div className="mt-2 border rounded-md p-3 bg-gray-50">
              <p className="text-[#002855] font-medium">
                {t("initialDayDecision")}
              </p>
              <div className="flex flex-wrap gap-2 mb-3">
                {obj?.verdict_given_on_intialday_ins && (
                  <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-700 border border-green-200">
                    {t("institution")}
                  </span>
                )}
                {obj?.verdict_given_on_intialday_accused && (
                  <span className="px-2 py-1 text-xs rounded bg-indigo-100 text-indigo-700 border border-indigo-200">
                    {t("accused")}
                  </span>
                )}
              </div>
              {obj?.council_decision_day && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="block text-gray-600">{t("decisionDay")}</p>
                  <p className="block text-black font-medium">
                    {(() => {
                      try {
                        const d = new Date(obj?.council_decision_day as any);
                        return isNaN(d.getTime())
                          ? (obj?.council_decision_day as any)
                          : d.toDateString();
                      } catch {
                        return (obj?.council_decision_day as any) || "-";
                      }
                    })()}
                  </p>
                </div>
              )}
              {obj?.remaining_days_for_appeal !== undefined &&
                obj?.remaining_days_for_appeal !== null && (
                  <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                    <p className="block text-gray-600">
                      {t("remainingDaysForAppeal")}
                    </p>
                    <p className="block text-black font-medium">
                      {obj?.remaining_days_for_appeal}
                    </p>
                  </div>
                )}
              {obj?.given_order && (
                <div className="w-full flex flex-wrap items-start justify-between gap-4 my-2">
                  <p className="block text-gray-600">{t("givenOrder")}</p>
                  <p className="block text-black text-sm max-w-md whitespace-pre-line">
                    {obj?.given_order}
                  </p>
                </div>
              )}
              {obj?.council_decision_type && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="block text-gray-600">{t("decisionType")}</p>
                  <p className="block text-black font-medium">
                    {obj?.council_decision_type}
                  </p>
                </div>
              )}
              {/* {obj?.discipline_measure_type && (
                  <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                    <p className="block text-gray-600">
                      Discipline Measure Type
                    </p>
                    <p className="block text-black font-medium">
                      {obj?.discipline_measure_type}
                    </p>
                  </div>
                )} */}
              {obj?.initial_day_council_decision_files && (
                <div className="w-full flex flex-wrap items-center justify-between gap-4 my-2">
                  <p className="block text-gray-600">{t("decisionFile")}</p>
                  <p
                    className="block text-black text-sm font-medium truncate max-w-xs"
                    title={obj?.initial_day_council_decision_files?.name}
                  >
                    {obj?.initial_day_council_decision_files?.name || "File"}
                  </p>
                </div>
              )}
            </div>

            {/* Info Rows */}
            <div className="my-3">
              <p className="text-[#002855] font-medium">
                {t("councilDecisionSummary")}
              </p>
              <p className="text-gray-700 mt-1">
                {obj?.council_decision_summary}
              </p>
            </div>

            {/* Core Metadata */}
            <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
              {obj?.accused_prosecutor_name && (
                <div className="flex items-center justify-between">
                  <p className="text-gray-600">{t("accusedProsecutor")}</p>
                  <p className="text-black font-medium">
                    {obj.accused_prosecutor_name}
                  </p>
                </div>
              )}

              {obj?.appeal_request_ins_prosecutor && (
                <div className="flex items-center justify-between">
                  <p className="text-gray-600">{t("appealRequest")}</p>
                  <p
                    className="text-black font-medium truncate max-w-[60%]"
                    title={
                      typeof obj.appeal_request_ins_prosecutor === "object"
                        ? (obj.appeal_request_ins_prosecutor as any)
                            ?.registration_number ||
                          (obj.appeal_request_ins_prosecutor as any)?.id
                        : String(obj.appeal_request_ins_prosecutor)
                    }
                  >
                    {typeof obj.appeal_request_ins_prosecutor === "object"
                      ? (obj.appeal_request_ins_prosecutor as any)
                          ?.registration_number ||
                        (obj.appeal_request_ins_prosecutor as any)?.id ||
                        "-"
                      : String(obj.appeal_request_ins_prosecutor)}
                  </p>
                </div>
              )}
            </div>

            {/* Documents */}
            {Array.isArray(obj?.documents) && obj.documents.length > 0 && (
              <div className="mt-4">
                <DocumentViewerModal
                  documents={obj.documents as any}
                  baseUrl={`${process.env.REACT_APP_API_BASE_URL}prosecutor-decipiline/complaint-termination-documents/document`}
                />
              </div>
            )}

            {showHearingHistory && (
              <button
                className="w-full bg-[#5f5f5f] hover:bg-gray-800 border border-white text-white py-2 rounded-lg mt-2"
                onClick={() => {
                  setSelectedAppeal(obj);
                  setShowDailyHearing(true);
                }}
              >
                {t("showDailyHearingHistory")}
              </button>
            )}
            {/* Removed appeal-related actions for verdict view */}

            {/* {complaintData && (
            <AddAppealFeedbackModal
              isOpen={isFeedbackOpen}
              setIsOpen={setIsFeedbackOpen}
              complaintData={complaintData}
              councilLitigationData={selectedAppeal}
              onRefresh={onAppealRefresh}
            />
          )}

          {selectedAppeal && isOpen && (
            <AddAppealRegistrationModal
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              complaintData={complaintData}
              councilLitigationData={selectedAppeal}
              onRefresh={onAppealRefresh}
            />
          )} */}
          </div>
        ),
      )}

      {/* {complaintData && (
        <HearingHistoryModal
          isOpen={!!showDailyHearing}
          onClose={() => setShowDailyHearing(false)}
          councilLitigationData={selectedAppeal}
          complaintData={complaintData}
        />
      )} */}
    </div>
  );
}
